/**
 * Onde o assistente aparece — UMA resposta, para dois interessados.
 *
 * O `Assistente` decide com isto se renderiza; o `ModuleFrame` decide com isto se
 * reserva espaço no fim da tela para o botão flutuante não cobrir a última linha.
 * Se cada um calculasse por conta própria, um dia o botão apareceria sem o respiro.
 */
import { useMatch } from 'react-router'

import { useFlag } from '@/flags/flags'

/** Os três módulos de cliente — inclusive Compliance, de onde se pergunta sobre os outros dois. */
const MODULOS_COM_ASSISTENTE = ['finops', 'orcamento', 'compliance']

export function useAssistenteVisivel(): boolean {
  const rota = useMatch('/cliente/:idCliente/:modulo/*')
  // BR-11: com a flag desligada, NADA é renderizado — nem o botão.
  const ligado = useFlag('assistenteIa')
  return ligado && MODULOS_COM_ASSISTENTE.includes(rota?.params.modulo ?? '')
}
